import authInstance from "../Interceptor";

export const setAuthHeader = (token) => {
  if (token) {
    localStorage.setItem("accessToken", token);
  } else {
    localStorage.removeItem("accessToken");
  }
};

export const AuthEffect = (formData) => {
  return authInstance.post("/auth/login", formData);
};

export const SignUpEffect = (data) => {
  return authInstance.post("/auth/register", data);
};

export const OtpSendEffect = (data) => {
  return authInstance.post("/auth/otpsend", data);
};

export const VerifyOtpEffect = (data) => {
  return authInstance.post("/auth/verifyotp", data);
};

export const MobileOtpSendEffect = (data) => {
  return authInstance.post("/auth/phoneOtp", data);
};

export const VerifyMobileOtpEffect = (data) => {
  return authInstance.post("/auth/verifyotp", data);
};

export const ForgotPasswordEffect = (data) => {
  return authInstance.post("/auth/forgotpassword", data);
};

export const ChangePasswordEffect = (data) => {
  return authInstance.put("auth/changepassword", data);
};

export const AdminEditEffect = (updatedData) => {
  return authInstance.put(`/profile/update`, updatedData);
};

export const AdminViewEffect = (adminId) => {
  // return authInstance.get(`/admin/getbooze?booze_id=${adminId}`);
};

export const RefreshTokenEffect = (data) => {
  return authInstance.post("/auth/refreshtoken", data);
};

export const LogoutEffect = (data) => {
  return authInstance.post("/logout", data);
};
